import { Utils } from 'choerodon-ui/dataset';
const isEmpty = Utils.isEmpty;
export default isEmpty;
